import type { Migration } from '../../types';
import { logger } from '../../utils/logger';
import { authenticatedFetch } from '../../utils/authenticatedFetch';
import { getV2AuthHeaders } from '../../utils/authHeaders';
import { getEnv } from '../../config/env';

const fetchMigrationsFromService = async (
  bearerToken: string,
  customerIds: string[]
): Promise<Migration[]> => {
  try {
    const baseUrl = getEnv().VITE_EDCI_API_URL;

    // Build query string with companyIds array
    const queryParams = customerIds.map((id) => `companyIds=${encodeURIComponent(id)}`).join('&');
    const url = `${baseUrl}/api/migrations/migrations?${queryParams}`;

    const response = await authenticatedFetch(url, {
      method: 'GET',
      headers: getV2AuthHeaders(bearerToken)
    });

    if (!response.ok) {
      logger.error('Migration API returned error', {
        status: response.status,
        statusText: response.statusText,
        url,
        organizationCount: customerIds.length
      });
      throw new Error(`Error fetching migrations: ${response.status} ${response.statusText}`);
    }

    // API returns Migration objects directly
    const data: Migration[] = await response.json();
    logger.debug('Migrations fetched successfully', {
      count: data.length,
      organizationCount: customerIds.length
    });
    return data;
  } catch (error) {
    const msg = error instanceof Error ? error.message : String(error);
    logger.error('Failed to fetch migrations', {
      error: msg,
      organizationCount: customerIds.length,
      url: `${getEnv().VITE_EDCI_API_URL}/api/migrations/migrations`
    });
    throw error;
  }
};

export default fetchMigrationsFromService;
